<template>
  <div class="r-switch-button" :class="{ [position]: position, selected }">
    <r-button
      :label="label"
      :color="computedColor"
      :text-color="computedTextColor"
      :size="size"
      :unelevated="unelevated"
      :custom-class="{ 'r-text-bold': selected, 'full-width': true }"
      :custom-style="buttonBorderRadiusStyle"
      @click="$emit('input', selectOn)"/>
  </div>
</template>

<script>
import RButton from '@/components/base/RButton';

export default {
  name: 'RSwitchButton',
  components: { RButton },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    selectOn: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    defaultColor: {
      type: String,
      required: true,
    },
    selectedColor: {
      type: String,
      required: true,
    },
    defaultTextColor: {
      type: String,
      default: 'white',
    },
    selectedTextColor: {
      type: String,
      default: 'white',
    },
    size: {
      type: String,
      default: 'xl',
    },
    unelevated: Boolean,
    position: {
      type: String,
      default: 'middle',
      validator: value => ['middle', 'first', 'last'].includes(value),
    },
  },
  computed: {
    selected() {
      return this.value === this.selectOn;
    },
    computedColor() {
      return this.selected ? this.selectedColor : this.defaultColor;
    },
    computedTextColor() {
      return this.selected ? this.selectedTextColor : this.defaultTextColor;
    },
    buttonBorderRadiusStyle() {
      switch (this.position) {
        case 'last': return 'border-radius: 2px 0 0 2px';
        case 'first': return 'border-radius: 0 2px 2px 0;';
        default: return 'border-radius: 0';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/styles/riseup.brand";

.r-switch-button {
  border: 1px $riseup-black solid;
  flex: 1;
  border-radius: 3px;

  &.selected {
    border-color: $riseup-blue;
  }

  &.first {
    border-radius: 4px 0 0 4px;
    border-right: 0;
  }

  &.last {
    border-radius: 0 4px 4px 0;
    border-left: 0;
  }

  &.middle {
    border-radius: 0;
  }
}

</style>
